// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__ofLyj","bigColWidth":"Table_bigColWidth__1g6BF","biggerColWidth":"Table_biggerColWidth__2N-3s","row":"Table_row__r-byq","col":"Table_col__5_z7d"};